export const OPEN_USAGE_DETAILS = 'openUsageDetails';
